import { css } from 'lit';

export const nsOnboardingStyles = css`
  .welcome-text {
    position: absolute;
    font-size: var(--wa-font-size-5xl);
  }
  .ns-logo {
    width: 150px;
  }

  .onboarding-stages {
    position: relative;

    background-color: var(--primary-color);
    color: var(--ns-theme-white);

    display: flex;
    align-items: center;
    justify-content: center;

    text-align: center;

    padding: 0 var(--wa-space-m);

    height: 100vh;
    width: 600px;

    overflow: hidden;
  }

  .onboarding-stages.expired,
  .onboarding-stages.withdrawn,
  .onboarding-stages.invalid,
  .onboarding-stages.unauthorised {
    background: var(--ns-theme-charcoal-grey);
  }

  .onboarding-stages img.invitation-only-access {
    width: 50px;
  }

  .logo {
    width: 20px;
  }

  .card-wrapper {
    top: 0;
  }

  .stage-card {
    position: relative;
    padding: var(--wa-space-m);

    width: 400px;

    background-color: var(--primary-background-color);
    color: var(--ns-theme-charcoal-grey);

    border-radius: var(--wa-border-radius-l);

    text-align: left;
  }

  .stage-card.hide {
    display: none;
  }

  .review-form {
    display: flex;
    flex-direction: column;

    background: var(--primary-color);
    color: #fff;

    padding: var(--wa-space-m);

    width: 50%;

    border-radius: var(--wa-border-radius-l);

    box-shadow: 0 0 10px var(--primary-color);
  }

  .card-embedded-html {
    font-size: var(--wa-font-size-s);
  }

  .expanded-card {
    display: none;

    position: relative;
    padding: var(--wa-space-m);

    background-color: var(--ns-theme-porcelain);
    color: var(--ns-theme-charcoal-grey);

    border-radius: var(--wa-border-radius-l);

    text-align: left;

    overflow: hidden;
  }

  .expanded-card.show {
    display: block;
  }

  .stage-intro {
    width: 65%;
  }

  .step {
    width: 100px;
    height: 100px;
  }

  .stage {
    position: absolute;
    padding: 0 var(--wa-space-m);
  }

  .pre-multi-stage {
    position: relative;
  }

  .retry-card {
    transform: translate(0, 0);
    animation: fadeinBackward 1s cubic-bezier(0.43, 0.12, 0.39, 0.96);
  }

  .later-card {
    animation: fadeoutBackward 1s cubic-bezier(0.43, 0.12, 0.39, 0.96);
  }

  .position-card {
    position: fixed;
  }

  .layout.vertical.hide-card,
  .layout.horizontal.hide-card,
  .hide-card {
    display: none;
  }

  .step {
    opacity: 0;
    transform: scale(0);
  }

  .step.scale {
    opacity: 1;
    transform: scale(1);
  }

  .next-stage {
    text-align: left;
  }

  /* X-small */
  @media (max-width: 576px) {
    .form-cards-wrapper,
    .form-cards {
      width: 100%;
    }
    .stage-card {
      width: auto;
    }
    .card-title,
    .next-stage {
      font-size: var(--wa-font-size-xs);
    }
    .step {
      width: auto;
    }
  }

  @keyframes fadeinBackward {
    from {
      opacity: 0;

      transform: scale(0.7) translate(0, -120vh);
    }

    to {
      opacity: 1;

      transform: scale(1) translate(0, 0);
    }
  }

  @keyframes fadeoutBackward {
    from {
      opacity: 1;

      transform: scale(1) translate(0, 0);
    }

    to {
      opacity: 0;

      transform: scale(0.7) translate(0, 120vh);
    }
  }
`;
